export default "__VITE_ASSET__C_PDT1zR__"